export const version = '2.66.1'
